export default "__VITE_ASSET__MSNBt5iz__"